import { COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING, SPACING_DENSE, SPACING_HALF } from "helpers/spacings";
import React from "react";

const lineStyle = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
const secondaryColor = "rgba(0, 0, 0, 0.54)";

// Who and what the video is about, shown below highlight and reel videos.
// action: a button at the end of the row, eg the reel dialog's close
export default function VideoPlayerHeader({ avatar, title, titleSuffix, subtitle, aside, asideSubtitle, action }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: SPACING_HALF,
        minWidth: 0,
        padding: `15px ${SPACING}`,
        backgroundColor: COLOR_WHITE,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontWeight: 400,
        // the dialog is inverse (white text), the thumbnails sit on the light page
        color: "rgba(0, 0, 0, 0.87)",
      }}
    >
      {avatar && <div style={{ flex: "0 0 auto", display: "flex" }}>{avatar}</div>}
      <div style={{ flex: "1 1 auto", minWidth: 0 }}>
        <div style={{ ...lineStyle, fontSize: 14, fontWeight: 500 }}>
          {title}
          {titleSuffix && <span style={{ fontWeight: 400, color: secondaryColor }}> {titleSuffix}</span>}
        </div>
        {subtitle && (
          <div style={{ ...lineStyle, fontSize: 12, marginTop: SPACING_DENSE, color: secondaryColor }}>{subtitle}</div>
        )}
      </div>
      {aside && (
        <div style={{ flex: "0 0 auto", textAlign: "right", whiteSpace: "nowrap" }}>
          <div style={{ fontSize: 14, fontWeight: 500 }}>{aside}</div>
          {asideSubtitle && (
            <div style={{ fontSize: 12, marginTop: SPACING_DENSE, color: secondaryColor }}>{asideSubtitle}</div>
          )}
        </div>
      )}
      {action && <div style={{ flex: "0 0 auto", display: "flex" }}>{action}</div>}
    </div>
  );
}
